import { observable } from "mobx";
import FuelTypeChangeRejectionReason from "./fuelTypeChangeRejectionReason";
import type FuelTypeChangeWarningReason from "./fuelTypeChangeWarningReason";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class FuelTypeChangePreviewResponse {
  /**
   * If true - change can be submitted.
   */
  @observable
  canBeSubmitted!: boolean;

  /**
   * Requested fuel type ID.
   */
  @observable
  fuelTypeId!: string;

  /**
   * Official record ID.
   */
  @observable
  officialRecordId!: string;

  /**
   * E-mail address.
   */
  @observable
  emailAddress?: string;

  @observable
  rejectionReason?: FuelTypeChangeRejectionReason;

  /**
   * Allowed fuel type ID derived from vehicle register data (fuel type and emissions).
   */
  @observable
  allowedFuelTypeId?: string;

  /**
   * Warning reasons.
   */
  @observable
  warningReasons!: FuelTypeChangeWarningReason[];
}
